import dayjs from "dayjs";

export function capitalizeFirstLetter(value: string): string {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export const formatDate = (dateString?: string): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateLong = (dateString?: string): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatDateCustom = (
  dateString?: string,
  format = "MM/DD/YYYY",
): string => {
  if (!dateString) return "";
  const date = dayjs(dateString);
  return date.isValid() ? date.format(format) : "Invalid Date";
};

export const truncateText = (content: string, maxLength = 100): string => {
  if (!content) return "";
  const text = content.replaceAll(/<[^>]*>/gi, "");
  return text.length <= maxLength
    ? text
    : `${text.substring(0, maxLength).trim()}...`;
};

export const truncateTitle = (title: string, maxLength = 50): string => {
  if (!title) return "";
  return title.length <= maxLength
    ? title
    : `${title.substring(0, maxLength).trim()}...`;
};

export const capitalize = (text: string): string => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const toTitleCase = (text: string): string => {
  if (!text) return "";
  return text
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const stripHtmlTags = (html: string): string => {
  if (!html) return "";
  return html.replaceAll(/<[^>]*>/gi, "");
};

export const escapeHtml = (text: string): string => {
  if (!text) return "";
  return text
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
};
